import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign } from "../../../Constants/utils";
import { getSalesCount } from "../../../Redux/features/Dashboard/Charts/salesCountSlice";
import { priceFormate } from "../../../hooks/priceFormate";
import { CommonChart } from "./CommonChart";

export const SalesCountChart = ({
  merchantId,
  activeType,
  presentDate,
  salesCountChartInView,
  salesCountChartRef,
  selectedOutletIds = [],
}) => {
  const salesCountChart = useSelector((state) => state.salesCountChart);

  const chartKey = "salesCountChart";

  return (
    <>
      <CommonChart
        componentRef={salesCountChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getSalesCount}
        yAxisText={"Total Transactions"}
        reduxState={salesCountChart}
        reduxStateKey={"salesCountData"}
        reduxStateTotalKey={"totalSalesCount"}
        valueKey={"sale_count"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={salesCountChartInView}
        title={"Total Transactions"}
        totalValueFunction={priceFormate}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
